<template>
	<div class="lema-empty">
		<div class="lema-empty__art">
			<svg viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
				<circle cx="48" cy="48" r="46" fill="url(#veGrad)" opacity="0.10" />
				<rect x="24" y="20" width="40" height="52" rx="7" fill="#ffffff" stroke="#c9d8ee" stroke-width="2" />
				<line x1="32" y1="32" x2="52" y2="32" stroke="#d7e2f2" stroke-width="3" stroke-linecap="round" />
				<line x1="32" y1="41" x2="48" y2="41" stroke="#e2ebf7" stroke-width="3" stroke-linecap="round" />
				<line x1="32" y1="50" x2="45" y2="50" stroke="#e2ebf7" stroke-width="3" stroke-linecap="round" />
				<circle cx="62" cy="60" r="15" fill="#ffffff" stroke="url(#veGrad)" stroke-width="3.5" />
				<line x1="73" y1="71" x2="82" y2="80" stroke="url(#veGrad)" stroke-width="4" stroke-linecap="round" />
				<defs>
					<linearGradient id="veGrad" x1="24" y1="20" x2="82" y2="80" gradientUnits="userSpaceOnUse">
						<stop stop-color="#3aa6a6" />
						<stop offset="1" stop-color="#2d8b8b" />
					</linearGradient>
				</defs>
			</svg>
		</div>
		<p class="lema-empty__title">{{ title }}</p>
		<p class="lema-empty__subtitle" v-if="subtitle">{{ subtitle }}</p>
		<slot name="action"></slot>
	</div>
</template>

<script>
export default {
	name: 'EmptyState',
	props: {
		title: {
			type: String,
			default: 'موردی یافت نشد',
		},
		subtitle: {
			type: String,
			default: 'داده‌ای برای نمایش وجود ندارد',
		},
	},
};
</script>

<style scoped lang="scss">
.lema-empty {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 44px 20px;
	width: 100%;

	&__art {
		width: 96px;
		height: 96px;
		margin-bottom: 18px;
		animation: veFloat 4s ease-in-out infinite;

		svg {
			width: 100%;
			height: 100%;
			filter: drop-shadow(0 12px 22px rgba(45, 139, 139, 0.14));
		}
	}

	&__title {
		font-size: 15px;
		font-weight: 700;
		color: #33415a;
		margin: 0 0 6px;
	}

	&__subtitle {
		font-size: 13px;
		color: #8a97ad;
		margin: 0;
		line-height: 1.7;
	}
}

@keyframes veFloat {
	0%,
	100% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-6px);
	}
}
</style>
